import React from "react";
import { useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

import ChildRoutes from "./ChildRoutes";

const SidebarNavList = (props) => {
  const { pages, depth, user } = props;
  const router = useLocation();
  const currentRoute = router.pathname;
  const childRoutes = pages.reduce(
    (items, page) => ChildRoutes({ items, page, currentRoute, depth }),
    [],
  );

  return <React.Fragment>{childRoutes}</React.Fragment>;
};

export default SidebarNavList;
